// extracted by mini-css-extract-plugin
export var adminLinkTag = "_b-1q";
export var assigneePill = "_b-2m";
export var assigneesList = "_b-2l";
export var automationCard = "_b-50";
export var automationDetails = "_b-52";
export var automationLabel = "_b-54";
export var automationList = "_b-4z";
export var automationNotConfigured = "_b-56";
export var automationRow = "_b-53";
export var automationTitle = "_b-51";
export var automationValue = "_b-55";
export var backButton = "_b-1n";
export var cancelButton = "_b-24";
export var cardLabel = "_b-4h";
export var cardValue = "_b-4i";
export var configActions = "_b-6s";
export var configAssignee = "_b-5t";
export var configAssigneeDept = "_b-5v";
export var configAssigneeName = "_b-5u";
export var configAssignees = "_b-5s";
export var configContent = "_b-5f";
export var configDeactivateButton = "_b-6t";
export var configDeleteButton = "_b-6u";
export var configEmpty = "_b-5e";
export var configHeader = "_b-5g";
export var configLabel = "_b-5l";
export var configLabelWithIcon = "_b-5m";
export var configLoading = "_b-5d";
export var configNotes = "_b-5w";
export var configRow = "_b-5k";
export var configSection = "_b-5i";
export var configSectionTitle = "_b-5j";
export var configStatusCard = "_b-5p";
export var configStatusRow = "_b-5o";
export var configStep = "_b-5y";
export var configStepCount = "_b-61";
export var configStepHeader = "_b-5z";
export var configStepName = "_b-60";
export var configStepSkipped = "_b-65";
export var configStepSkippedBadge = "_b-66";
export var configStepsList = "_b-5x";
export var configSubstep = "_b-63";
export var configSubstepSkipped = "_b-64";
export var configSubsteps = "_b-62";
export var configValue = "_b-5n";
export var confirmButton = "_b-25";
export var contentGrid = "_b-37";
export var contentLoading = "_b-1j";
export var coverageDetails = "_b-4k";
export var coverageSection = "_b-4j";
export var dealSizeField = "_b-2g";
export var dealSizeInput = "_b-2f";
export var dealSizeSaveButton = "_b-2h";
export var deleteModal = "_b-6v";
export var detailPanelsContainer = "_b-2j";
export var detailsGrid = "_b-i";
export var dollarSign = "_b-2e";
export var editButton = "_b-2i";
export var editConfigButton = "_b-5h";
export var emptyState = "_b-j";
export var emptyStateText = "_b-l";
export var emptyStateTitle = "_b-k";
export var emptyText = "_b-4d";
export var errorContainer = "_b-1i";
export var expandButton = "_b-3e";
export var gridCard = "_b-4g";
export var headerActions = "_b-1v";
export var headerTags = "_b-1p";
export var hubspotLink = "_b-5q";
export var hubspotLinkTag = "_b-1t";
export var hubspotLinkText = "_b-5r";
export var infoCard = "_b-4c";
export var kpiDivider = "_b-2d";
export var kpiItem = "_b-29";
export var kpiLabel = "_b-2a";
export var kpiRow = "_b-27";
export var kpiSpacer = "_b-28";
export var kpiValue = "_b-2c";
export var kpiValueContainer = "_b-2b";
export var leftColumn = "_b-38";
export var loadMoreButton = "_b-36";
export var loadMoreContainer = "_b-35";
export var loadingContainer = "_b-1h";
export var loadingIcon = "_b-1k";
export var loadingIconSmall = "_b-5c";
export var metaSection = "_b-1m";
export var notStartedTag = "_b-1r";
export var notePill = "_b-47";
export var notePillHeader = "_b-48";
export var notePillStep = "_b-49";
export var notePillText = "_b-4b";
export var notePillTimestamp = "_b-4a";
export var notesGrid = "_b-46";
export var oeConfigLabel = "_b-69";
export var oeConfigRow = "_b-68";
export var oeConfigValue = "_b-6a";
export var oeEditWindowGroup = "_b-67";
export var oePlatformsList = "_b-6n";
export var oeProgressBadge = "_b-6o";
export var oeStepItem = "_b-6q";
export var oeStepItemCompleted = "_b-6r";
export var oeStepsList = "_b-6p";
export var oeSubOption = "_b-6j";
export var oeSubOptionActive = "_b-6k";
export var oeSubOptionDot = "_b-6m";
export var oeSubOptionIcon = "_b-6l";
export var oeSubOptions = "_b-6i";
export var oeToolDuration = "_b-6g";
export var oeToolHeader = "_b-6e";
export var oeToolItem = "_b-6c";
export var oeToolItemEnabled = "_b-6d";
export var oeToolName = "_b-6f";
export var oeToolToggle = "_b-6h";
export var oeToolsList = "_b-6b";
export var pageContainer = "_b-1g";
export var pageTitle = "_b-1o";
export var pageWrapper = "_b-0";
export var paymentCard = "_b-4q";
export var paymentLabel = "_b-4s";
export var paymentRow = "_b-4r";
export var paymentValue = "_b-4t";
export var portalCard = "_b-4u";
export var portalLabel = "_b-4w";
export var portalLogo = "_b-4y";
export var portalRow = "_b-4v";
export var portalValue = "_b-4x";
export var preInstallBadge = "_b-1s";
export var productNavBar = "_b-3";
export var productStatusDot = "_b-6";
export var productStatusDotComplete = "_b-7";
export var productStatusDotHelpRequested = "_b-b";
export var productStatusDotInProgress = "_b-8";
export var productStatusDotNotStarted = "_b-a";
export var productStatusDotReopened = "_b-9";
export var productTab = "_b-4";
export var productTabActive = "_b-5";
export var progressBar = "_b-3l";
export var progressBarFill = "_b-3m";
export var progressCard = "_b-3f";
export var progressCircle = "_b-o";
export var progressCircleBg = "_b-p";
export var progressCircleFill = "_b-q";
export var progressCircleText = "_b-r";
export var progressLabel = "_b-3h";
export var progressMeta = "_b-3g";
export var progressPercent = "_b-3n";
export var progressStats = "_b-3i";
export var progressSubvalue = "_b-3k";
export var progressSummary = "_b-m";
export var progressSummaryDetail = "_b-v";
export var progressSummaryInfo = "_b-s";
export var progressSummaryMain = "_b-n";
export var progressSummarySubtitle = "_b-u";
export var progressSummaryTitle = "_b-t";
export var progressValue = "_b-3j";
export var pushActions = "_b-20";
export var pushButton = "_b-1x";
export var pushButtonContainer = "_b-1w";
export var pushButtonSuccess = "_b-1z";
export var pushDateInfo = "_b-2p";
export var pushDateText = "_b-1y";
export var pushToggle = "_b-22";
export var pushTogglesContainer = "_b-21";
export var pushWarning = "_b-2n";
export var pushWarningPill = "_b-2o";
export var replayLinkTag = "_b-1u";
export var returnFlowCard = "_b-57";
export var returnFlowStat = "_b-59";
export var returnFlowStatLabel = "_b-5a";
export var returnFlowStatValue = "_b-5b";
export var returnFlowSummary = "_b-58";
export var rightColumn = "_b-39";
export var section = "_b-3a";
export var sectionCheckbox = "_b-3d";
export var sectionHeader = "_b-3b";
export var sectionTitle = "_b-3c";
export var selectAllButton = "_b-23";
export var sessionBadge = "_b-26";
export var sessionButton = "_b-34";
export var sessionDate = "_b-2z";
export var sessionInfo = "_b-2x";
export var sessionItem = "_b-2v";
export var sessionItemActive = "_b-2w";
export var sessionMeta = "_b-30";
export var sessionMetaItem = "_b-31";
export var sessionMetaLabel = "_b-32";
export var sessionMetaValue = "_b-33";
export var sessionTitle = "_b-2y";
export var sessionsButton = "_b-2k";
export var sessionsContainer = "_b-2q";
export var sessionsEmpty = "_b-2t";
export var sessionsHeader = "_b-2r";
export var sessionsList = "_b-2u";
export var sessionsLoading = "_b-2s";
export var spin = "_b-1l";
export var stepCard = "_b-x";
export var stepCardCircle = "_b-12";
export var stepCardCircleComplete = "_b-14";
export var stepCardCirclePartial = "_b-13";
export var stepCardComplete = "_b-y";
export var stepCardCount = "_b-16";
export var stepCardHeader = "_b-10";
export var stepCardPartial = "_b-z";
export var stepCardStatus = "_b-11";
export var stepCardSubsteps = "_b-17";
export var stepCardTitle = "_b-15";
export var stepDuration = "_b-3v";
export var stepHeader = "_b-3t";
export var stepItem = "_b-3p";
export var stepItemCompleted = "_b-3q";
export var stepItemExpanded = "_b-3s";
export var stepItemPartial = "_b-3r";
export var stepName = "_b-3u";
export var stepToggle = "_b-3w";
export var stepToggleOpen = "_b-3y";
export var stepTogglePlaceholder = "_b-3x";
export var stepsGrid = "_b-w";
export var stepsList = "_b-3o";
export var substepBullet = "_b-44";
export var substepCompleted = "_b-41";
export var substepDuration = "_b-45";
export var substepIcon = "_b-43";
export var substepItem = "_b-40";
export var substepName = "_b-42";
export var substepRow = "_b-18";
export var substepRowComplete = "_b-19";
export var substepRowDot = "_b-1b";
export var substepRowIcon = "_b-1a";
export var substepRowName = "_b-1c";
export var substepRowTime = "_b-1d";
export var substepsList = "_b-3z";
export var tab = "_b-f";
export var tabActive = "_b-g";
export var tabBar = "_b-e";
export var tabBarContainer = "_b-c";
export var tabBarContent = "_b-d";
export var tabContent = "_b-h";
export var tag = "_b-4o";
export var tagEmpty = "_b-4p";
export var tagLabel = "_b-4m";
export var tagList = "_b-4n";
export var tagSection = "_b-4l";
export var threeColGrid = "_b-4f";
export var topHeader = "_b-1";
export var topHeaderContent = "_b-2";
export var topHeaderLeft = "_b-1f";
export var topHeaderMain = "_b-1e";
export var twoColGrid = "_b-4e";